"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = exports.TypeOfSensor = exports.Connectivity = exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["COUNTING"] = "counting";
    DeviceType["AIR"] = "air";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var Connectivity;
(function (Connectivity) {
    Connectivity["LORAWAN"] = "LoRaWan";
    Connectivity["WIFI_ETHERNET"] = "WifiEthernet";
})(Connectivity = exports.Connectivity || (exports.Connectivity = {}));
var TypeOfSensor;
(function (TypeOfSensor) {
    TypeOfSensor["MAT"] = "Mat";
    TypeOfSensor["CAMERA"] = "Camera";
    TypeOfSensor["PROBE"] = "Probe";
    TypeOfSensor["IR_SENSOR"] = "IRSensor";
    TypeOfSensor["SPIDER_PROCESSING_UNIT"] = "SpiderProcessingUnit";
})(TypeOfSensor = exports.TypeOfSensor || (exports.TypeOfSensor = {}));
var Application;
(function (Application) {
    Application["COUNTING"] = "Counting";
    Application["THERMAL"] = "Thermal";
    Application["QUEUE_DETECTION"] = "QueueDetection";
    Application["DEMOGRAPHICS"] = "Demographics";
    Application["AIR_QUALITY"] = "AirQuality";
    Application["TRACKING"] = "Tracking";
})(Application = exports.Application || (exports.Application = {}));
